export const handleImage = (image) => {
  if (image) {
    if (!image.includes("http"))
      // eslint-disable-next-line no-undef
      image = `${process.env.NEXT_PUBLIC_MAIN_URL}/${image}`;
    return image;
  }
  // eslint-disable-next-line no-undef
  return image || process.env.NEXT_PUBLIC_MAIN_URL;
};
